module.exports = __webpack_public_path__ + "static/media/nav-icon-1-on-1-active.7c575177.svg";